import React, { useContext } from "react";
import styled from "styled-components";

import SearchBar from "../common/SearchBar";
import Typography from "@material-ui/core/Typography";

import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import SearchIcon from "@material-ui/icons/Search";

import { AppContext } from "./AppContext";

export default React.memo(function SearchTitle({ showSearch, setSelectedId }) {
  /**
   * Grab what we need from contexts
   */
  const { setMenuOpen, setActiveFeatures, activeFeatures } = useContext(
    AppContext
  );

  /**
   * Remove the currently selected features
   */
  const removeSelection = () => {
    setActiveFeatures();
    setSelectedId();
  };

  return (
    <SearchBar>
      <IconButton onClick={() => setMenuOpen(true)} aria-label="menu">
        <MenuIcon />
      </IconButton>
      <Title onClick={showSearch}>
        {activeFeatures
          ? activeFeatures.features[0].properties.address
          : "Search developments"}
      </Title>
      {activeFeatures ? (
        <IconButton onClick={removeSelection} aria-label="remove development selection">
          <CloseIcon />
        </IconButton>
      ) : (
        <IconButton onClick={showSearch} aria-label="search developments">
          <SearchIcon />
        </IconButton>
      )}
    </SearchBar>
  );
});

const Title = styled(Typography).attrs({ variant: "body2" })`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 20px !important;
  color: ${({ theme, children }) => children === "Search developments" ? theme.palette.grey400 : theme.palette.grey800};
  opacity: .7;
  position: relative;
  top: -1px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
`;
